import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/Main.css'

gsap.registerPlugin(ScrollTrigger);

const Header = () => {
  const contentRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    tl.fromTo(titleRef.current,
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, delay: 0.3 }
    )
    .fromTo(textRef.current,
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8 },
      '-=0.5'
    );

    // Add scroll trigger for replay on scroll
    gsap.to(contentRef.current, {
      scrollTrigger: {
        trigger: contentRef.current,
        start: 'top bottom',
        end: 'top top',
        toggleActions: 'play none none none',
        onEnter: () => {
          // Replay animation when scrolling back up
          tl.restart();
        }
      }
    });

    return () => tl.kill();
  }, []);

  return (
    <div className="main-container">
      <video autoPlay muted loop className="background-video">
        <source src="/general (1).mp4" type="video/mp4" />
       
      </video>

<div className="overlay-content" ref={contentRef}>
  <h1 ref={titleRef}>
    Quality, Efficiency, <span className="green-color">Reliability</span>
  </h1>



        <p ref={textRef}>Automotive Devices excels in transforming design into reality with precision PCBA Prototyping and seamless production scaling</p>
      </div>
    </div>
  );
};

export default Header;
